import {
  Mapping,
  MappingIdentifier,
  MappingIdentifierType,
} from 'src/containers/ProjectDiagram/types/data';
import {
  Model,
  ModelSnapshot,
} from 'src/containers/ProjectDiagram/types/model';
import * as copy from 'src/templates/copy';

export const isValidMapping =
  (mapping: Mapping) => (model: Model | ModelSnapshot) => {
    return !getReasonsForInvalidMapping(mapping)(model);
  };

export const isValidClassMapping = (mapping: Mapping) =>
  !getReasonsForInvalidClassMapping(mapping).length;

export const isValidPrimaryIdentifier = (identifier: MappingIdentifier) =>
  identifier.parts.some((part) => part.type === MappingIdentifierType.FIELD);

export const getReasonsForInvalidClassMapping = (
  mapping: Mapping,
  reasons?: string[]
) => {
  const reasonsArr = reasons || [];
  if (!isValidPrimaryIdentifier(mapping.primaryIdentifier)) {
    reasonsArr.push(
      copy.components.invalidMappings.validation.primaryIdentifier(mapping.text)
    );
  }
  return reasonsArr;
};

export const getReasonsForInvalidMapping =
  (mapping: Mapping) =>
  (
    model: Model | ModelSnapshot
  ): {
    reasons: string[];
    /** don't notify user about this because they probably already know it's not connected */
    quiet: boolean;
  } | null => {
    const reasons: string[] = [];
    let quiet = false;

    const linkData =
      mapping.to && model.nodeDataArray.find((node) => node.key === mapping.to);
    if (!mapping.to || !linkData) {
      reasons.push(copy.components.invalidMappings.validation.to(mapping.text));

      // we don't want to notify the user about unconnected mappings
      quiet = true;
    } else {
      getReasonsForInvalidClassMapping(mapping, reasons);
    }

    return reasons.length ? { reasons, quiet } : null;
  };
